import React, {useContext, useEffect} from "react";
import {
    AllNodesSearchContext
} from "../../../../infecto-lms-webapp/context/search-context/AllNodesSearchContextProvider";
import {useLazyLoadQuery, usePaginationFragment} from "react-relay";
import {useDeepCompareEffect} from "../../../../infecto-lms-webapp/hooks/useDeepCompareEffect";
import {TotalCountFilteredNodesComponent} from "../TotalCountFilteredNodes.component";
import {NodesCarousel} from "../../dashboard/NodesCarousel";
import {FRAGMENT, QUERY} from "./search-nodes-carousel.graphql";
import {SearchNodesCarouselProps} from "./search-nodes-carousel.types";
import {searchNodesCarouselComponent_Query} from "@generated/searchNodesCarouselComponent_Query.graphql";
import {searchNodesCarouselComponent_Refetch} from "@generated/searchNodesCarouselComponent_Refetch.graphql";
import {
    searchNodesCarouselComponent_NodeFragment$key
} from "@generated/searchNodesCarouselComponent_NodeFragment.graphql";


export const SearchNodesCarouselComponent = ({ elementType, setIsShowingModules }: SearchNodesCarouselProps) => {
    const { allNodesFilters } = useContext(AllNodesSearchContext);

    const query = useLazyLoadQuery<searchNodesCarouselComponent_Query>(
        QUERY,
        {
            ...allNodesFilters,
            elementTypes: [elementType],
            query: allNodesFilters.query ? allNodesFilters.query : undefined,
        },
        {
            fetchPolicy: "store-and-network",
        },
    );

    const { data, loadNext, hasNext, refetch } = usePaginationFragment<
        searchNodesCarouselComponent_Refetch,
        searchNodesCarouselComponent_NodeFragment$key
    >(FRAGMENT, query);

    const results =
        data.LearnV2.NodesSearchResult?.edges?.filter((e) => !!e?.node).map((e) => e!.node!) || [];

    useDeepCompareEffect(() => {
        refetch({
            ...allNodesFilters,
            elementTypes: [elementType],
            query: allNodesFilters.query ? allNodesFilters.query : undefined,
        });
    }, [allNodesFilters, elementType]);

    useEffect(() => {
        if (results.length > 0) {
            setIsShowingModules(prev =>
                prev.includes(elementType) ? prev : [...prev, elementType]
            );
        } else {
            setIsShowingModules(prev => prev.filter((et: string) => et !== elementType));
        }
    }, [allNodesFilters]);

    return (
        <div className="pb-5">
            {results.length > 0 ? (
                <div>
                    <TotalCountFilteredNodesComponent elementType={elementType} />
                    <NodesCarousel nodes={results} onLoadMore={() => loadNext(10)} hasNext={hasNext} />{" "}
                </div>
            ) : null}
        </div>
    );
};
